import Input from "../../Input"

const BanClientsChannel = ({ values, serverData }) => {
    return (
        <div className="mx-14 h-full">
            <h6 className="flex justify-center">چنل بن های سرور</h6>
            <div className="font-sans">
                <Input
                    type="number"
                    label="ایدی چنل *"
                    name="banClientsChannel-id"
                    options={serverData?.channelList}
                    placeholder="ChannelID"
                    autoComplete="off"
                    dir="ltr"
                    defaultValue={values?.id}
                />
            </div>
            <div className="mt-2">
                <Input
                    type="text"
                    label="فرمت اسم چنل *"
                    name="banClientsChannel-nameFormat"
                    id="bot-name"
                    placeholder="format"
                    autoComplete="off"
                    dir="ltr"
                    defaultValue={values?.nameFormat}
                />
            </div>
            <div className="mt-2">
                <label for="bot-name" class="block">
                    فرمت دسکریپشن چنل
                </label>
                <textarea
                    type="text"
                    name="banClientsChannel-descriptionFormat"
                    class="styled-input"
                    placeholder="format"
                    autoComplete="off"
                    dir="ltr"
                    defaultValue={values?.descriptionFormat}
                />
            </div>
            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>متغیرها:</span>
                <div dir="ltr">
                    <div>%c: تعداد</div>
                    <div>%r: دلیل بن</div>
                    <div>%n: یوزر بن</div>
                </div>
            </div>
        </div>
    )
}

export default BanClientsChannel
